/**
 * 求人詳細企業バナーに表示する会社名を生成する
 * @param corporateName
 */
export const createCompanyPageLinkName = (corporateName: string) => {
  const COMPANY_PAGE_LINK_NAME_STRING_MAX = 17;
  let companyPageLinkName = 'この企業';
  if (
    corporateName &&
    corporateName.length <= COMPANY_PAGE_LINK_NAME_STRING_MAX
  ) {
    companyPageLinkName = corporateName;
  }
  return {
    companyPageLinkName,
  };
};
